var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1396_8415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1396_8415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8275 89.4123L60 77.3161L80.2688 89.6336L74.99 66.7298L92.7113 51.4598L69.365 49.3548L60 27.7386L50.7313 49.2298L27.385 51.2386L45.1063 66.7298L39.8275 89.4123ZM32.2025 99.9986L39.5575 68.6236L15 47.4023L47.3462 44.6623L60 14.9986L72.75 44.6623L105.096 47.4023L80.5387 68.6236L87.8938 99.9986L60 83.2961L32.2025 99.9986ZM87.115 35.2873L89.3562 25.8923L81.8275 19.5761L91.75 18.7673L95.5775 9.90234L99.4038 18.7673L109.327 19.5761L101.798 25.8923L104.039 35.2873L95.5775 30.2773L87.115 35.2873Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.9194a86365066d86040dd28b323a8bdb.svg";
export { ForwardRef as ReactComponent };